import React from 'react'

const Hero = () => {
  return (
<div>

<section class="mb-40">
  

    <div class="text-center bg-gray-900 py-24 px-6">


      <h1 class="text-4xl md:text-6xl xl:text-7xl font-bold tracking-tight mb-5">
      <span class="bfont-bold text-transparent bg-clip-text 
      bg-gradient-to-r from-white via-gray-300 to-gray-100">Websites for you and your projects.</span></h1>

      <h5 class="text-xl md:text-xl xl:text-xl font-semibold tracking-tight mb-12">
      <span class=" text-transparent bg-clip-text 
      bg-gray-400">Hosted directly from your </span>
      <a className=" text-gray-400 hover:text-blue-700 hover:underline" href="https://github.com/polaamgad88/DirtyCode"> github repo</a> 
      <span class=" text-transparent bg-clip-text 
      bg-gray-400"> just edit, push, and your changes are live.</span></h5>



     
      



   
  </div>
</section>

</div>
  )
}

export default Hero;
